<template>
  <Card class="LicenseUsageSituation">
    <section>
      <Heading
        type="tertiary"
        level="2"
        :heading="messages.heading.licenseUsage"
      />
      <span v-if="assignableCount === 0" class="LicenseUsageSituation__text">{{
        messages.licenseUsage.info.noLicense
      }}</span>
      <span v-else class="LicenseUsageSituation__text">{{
        countDisplayLabel
      }}</span>
      <div class="LicenseUsageSituation__inner">
        <LicenseGraf
          class="LicenseUsageSituation__licenseGraf"
          :percentage="percentage"
        />
        <span class="LicenseUsageSituation__subText"
          >({{ licenseAssignmentCurrent }}/{{ licenseAssignmentLimit }})</span
        >
        <Button
          class="LicenseUsageSituation__button"
          tag="button"
          dynamics="secondary"
          :label="messages.licenseUsage.additionalPurchase"
          @click="onClickPurchase"
        />
      </div>
    </section>
  </Card>
</template>

<script lang="ts">
export default {
  name: 'LicenseUsageSituation',
};
</script>

<script lang="ts" setup>
import Button from '@spectee/components/Atoms/Button/index.vue';
import Card from '@spectee/components/Atoms/Card/index.vue';
import Heading from '@spectee/components/Atoms/Heading/index.vue';
import LicenseGraf from '@spectee/components/Atoms/LicenseGraf/index.vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import messages from '../../../messages.json';

const router = useRouter();

type Props = {
  licenseDisplayName: string | undefined;
  licenseAssignmentCurrent: number;
  licenseAssignmentLimit: number;
};

const props = defineProps<Props>();

const percentage = computed(() => {
  return (props.licenseAssignmentCurrent / props.licenseAssignmentLimit) * 100;
});

const assignableCount = computed(() => {
  return props.licenseAssignmentLimit - props.licenseAssignmentCurrent;
});

const onClickPurchase = () => {
  router.push({
    name: 'AdminContact',
    state: {
      from: 'LicenseManagement',
    },
  });
};

const countDisplayLabel = computed(() =>
  messages.licenseUsage.info.available.replace(
    '{{count}}',
    assignableCount.value.toString()
  )
);
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.LicenseUsageSituation {
  padding: $service-unit * 4 $service-unit * 4 $service-unit * 4;

  &__text {
    display: block;
    margin-top: $service-unit * 3;
    font-size: $service-font-size-p;
    font-weight: bold;
  }

  &__inner {
    display: flex;
    align-items: center;
  }

  & &__licenseGraf {
    width: $service-unit * 120;
  }

  &__subText {
    margin-left: $service-unit * 5;
    font-size: $service-font-size-p;
  }

  & &__button {
    margin-left: auto;
  }

  @media (max-width: 768px) {
    &__text {
      font-size: $service-font-size-mp;
    }
    &__subText {
      margin-left: $service-unit;
      margin-right: $service-unit;
    }

    & &__button {
      margin-left: $service-unit;
      height: $service-unit * 8;
    }
  }
}
</style>
